// extracted by mini-css-extract-plugin
export default {"overlay":"S_DateBirthPopup_overlay__4iuNr","wrapper":"S_DateBirthPopup_wrapper__708yh","title":"S_DateBirthPopup_title__M9xKr"};